import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const TIPOS_ACTIVIDAD_EXTCUR_CONST = 'tipos_actividad_extcur';

export const allTiposActividadesExtcurService = async (params) => {
  const res = await axios.get(`${baseUrl}/${TIPOS_ACTIVIDAD_EXTCUR_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveTiposActividadesExtcurService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(
      `${baseUrl}/${TIPOS_ACTIVIDAD_EXTCUR_CONST}/${id}`,
      data,
      {
        headers: token({}),
      },
    );
  } else {
    res = await axios.post(`${baseUrl}/${TIPOS_ACTIVIDAD_EXTCUR_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneTiposActividadesExtcurService = async (id) => {
  const res = await axios.get(
    `${baseUrl}/${TIPOS_ACTIVIDAD_EXTCUR_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};

export const deleteTiposActividadesExtcurService = async (id) => {
  const res = await axios.delete(
    `${baseUrl}/${TIPOS_ACTIVIDAD_EXTCUR_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};
